module.exports = __webpack_public_path__ + "img/nav-logo.2394449a.svg";